import { Theme } from "@/user/ThemeProvider";
import { apiCall } from "../../api/apiBase";

export interface User {
    id?: string;
    email: string;
    firstName: string;
    lastName: string;
    theme: Theme;
    isSuper?: boolean;
    createdAt?: string;
    updatedAt?: string;
}

export interface UserProfileUpdate {
    email: string;
    firstName: string;
    lastName: string;
    theme: Theme;
}

export interface UserSuperStatusUpdate {
    isSuper: boolean;
}

export interface UserThemeUpdate {
    theme: Theme;
}

export function getAllUsers(): Promise<User[]> {
    return apiCall<User[]>("/users", "GET");
}

export function createUser(user: User): Promise<User> {
    return apiCall<User>("/users", "POST", user);
}

export function getUser(userId: string): Promise<User> {
    return apiCall<User>(`/users/${userId}`, "GET");
}

export function deleteUser(userId: string): Promise<void> {
    return apiCall(`/users/${userId}`, "DELETE");
}

export function updateUserProfile(
    userId: string,
    profile: UserProfileUpdate
): Promise<User> {
    return apiCall<User>(`/users/${userId}/profile`, "PUT", profile);
}

export function updateUserSuperStatus(
    userId: string,
    superStatus: UserSuperStatusUpdate
): Promise<User> {
    return apiCall<User>(`/users/${userId}/super-status`, "PUT", superStatus);
}

export function updateUserTheme(
    userId: string,
    themeUpdate: UserThemeUpdate
): Promise<User> {
    return apiCall<User>(`/users/${userId}/theme`, "PUT", themeUpdate);
}
